module.exports = __webpack_public_path__ + "media/images/front/apple-touch-icon-e60c826f6c6f37ed9bb097dcd0573981.png";